export default __webpack_public_path__ + "static/1-ee51c4ebb059ee7ef6fd4014ec06bdc2.png";